import React from 'react';

const EmojiIcon = ({ emoji, label }) => (
  <span role="img" aria-label={label} className="sidebar-emoji-icon">
    {emoji}
  </span>
);

export const sportsConfig = [
  {
    key: 'cricket',
    label: 'Cricket',
    route: '/games/cricket',
    icon: <EmojiIcon emoji="🏏" label="Cricket" />,
    hasFeed: true,
    showArrow: true,
  },
  {
    key: 'soccer',
    label: 'Football',
    route: '/games/soccer',
    icon: <EmojiIcon emoji="⚽" label="Football" />,
    hasFeed: true,
    showArrow: true,
  },
  {
    key: 'tennis',
    label: 'Tennis',
    route: '/games/tennis',
    icon: <EmojiIcon emoji="🎾" label="Tennis" />,
    hasFeed: true,
    showArrow: true,
  },
  {
    key: 'cock-fight',
    label: 'Cock Fight',
    route: '/games/cock-fight',
    icon: <EmojiIcon emoji="🐓" label="Cock Fight" />,
    hasFeed: false,
    showArrow: false,
  },
  {
    key: 'politics',
    label: 'Politics',
    route: '/games/politics',
    icon: <EmojiIcon emoji="🗳️" label="Politics" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'casino',
    label: 'Casino',
    route: '/live-casino',
    icon: <EmojiIcon emoji="🎰" label="Casino" />,
    hasFeed: false,
    showArrow: false,
  },
  {
    key: 'sports-book',
    label: 'Sports Book',
    route: '/sports-book',
    icon: <EmojiIcon emoji="📖" label="Sports Book" />,
    hasFeed: false,
    showArrow: false,
  },
  {
    key: 'horse-racing',
    label: 'Horse Racing',
    route: '/games/horse-racing',
    icon: <EmojiIcon emoji="🏇" label="Horse Racing" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'greyhound-racing',
    label: 'Greyhound Racing',
    route: '/games/greyhound-racing',
    icon: <EmojiIcon emoji="🐕" label="Greyhound Racing" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'binary',
    label: 'Binary',
    route: '/games/binary',
    icon: <EmojiIcon emoji="📊" label="Binary" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'kabaddi',
    label: 'Kabaddi',
    route: '/games/kabaddi',
    icon: <EmojiIcon emoji="🤼" label="Kabaddi" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'basketball',
    label: 'Basketball',
    route: '/games/basketball',
    icon: <EmojiIcon emoji="🏀" label="Basketball" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'baseball',
    label: 'Baseball',
    route: '/games/baseball',
    icon: <EmojiIcon emoji="⚾" label="Baseball" />,
    hasFeed: false,
    showArrow: true,
  },
  {
    key: 'table-tennis',
    label: 'Table Tennis',
    route: '/games/table-tennis',
    icon: <EmojiIcon emoji="🏓" label="Table Tennis" />,
    hasFeed: false,
    showArrow: true,
  },
];

export const getSportByKey = (key) =>
  sportsConfig.find((sport) => sport.key === key);

export const sportsWithFeed = sportsConfig.filter((sport) => sport.hasFeed);
